import { Navigate } from 'react-router-dom';

import { MatchingRunScreen } from '@app/matching/components/MatchingRunScreen';
import { MATCHING_ROUTE } from '@app/matching/constants';
import { matchingSession } from '@app/matching/session';

// The no-run guard lives HERE, not in the screen: the session singleton re-evaluates on reload, so
// a reload or a cold deep-link has nothing to poll (AC-5). Guarding at the routing layer keeps the
// screen a plain data component — a guard inside it would either sit above its hooks (illegal hook
// order, and `rules-of-hooks` lint is OFF here) or below `useQuery`, which then demands an
// ApolloProvider just to render a redirect.
export const AdminMatchingRunPage = () => {
  const { runId } = matchingSession;

  if (!runId) {
    return <Navigate to={MATCHING_ROUTE} replace />;
  }

  return <MatchingRunScreen runId={runId} />;
};
